<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_COMPLETION')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_COMPLETION')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <div class="row" *ngIf="project?.date_completed">
            <div class="col">
                <div class="mb-2">
                    <label>Abgeschlossen am</label>
                    <p>{{ project?.date_completed | date: 'dd.MM.yyyy' }}</p>
                </div>
            </div>
        </div>

        <h4>Ziele</h4>
        <table class="table table-striped table-sm">
            <thead>
            <tr>
                <th>Text</th>
                <th style="width: 60px">Erfüllt</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let goal of project?.goals">
                    <td>
                        {{ goal.text }}
                    </td>
                    <td>
                        <span [class.text-danger]="!goal.completed" [class.text-success]="goal.completed">
                            {{ goal.completed | yesNo }}
                        </span>
                    </td>
            </tr>
            </tbody>
        </table>
        <div class="mb-2">
            <label>Kommentar</label>
            <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                <textarea class="form-control" formControlName="completion_goals_comment" rows="5" [maxlength]="500"
                      placeholder="Falls es ergänzende Bemerkungen oder Abweichungen zu den definierten Zielen gibt, können diese hier erläutert werden.">
                </textarea>
                <div class="mb-1 small">{{ form.value.completion_goals_comment ? form.value.completion_goals_comment.length : 0 }}/500</div>
            </ng-container>
            <p *ngIf="viewMode === ViewMode.VIEW">
                {{ form.value.completion_goals_comment }}
                <span class="text-muted" *ngIf="!form.value.completion_goals_comment">Nicht eingetragen</span>
            </p>
        </div>

        <h4>Zeit</h4>
        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Geplantes Projektende</label>
                    <p>{{ project?.dates_end_planned | date: 'dd.MM.yyyy' }}</p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Datum Projektabschluss eingereicht</label>
                    <p>{{ project?.date_completion_filed | date: 'dd.MM.yyyy' }}</p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Abweichung [Tage]</label>
                    <p
                        [class.text-danger]="project?.date_deviation > 0"
                        [class.text-success]="project?.date_deviation < 0"
                        ><span *ngIf="project?.date_deviation > 0">+</span>{{ project?.date_deviation }}</p>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <label>Kommentar</label>
            <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                <textarea class="form-control" formControlName="completion_time_comment" rows="5" [maxlength]="500"
                          placeholder="Falls es ergänzende Bemerkungen oder Abweichungen zu dem definierten Zeitplan/Terminen gibt, können diese hier erläutert werden.">
                </textarea>
                <div class="mb-1 small">{{ form.value.completion_time_comment ? form.value.completion_time_comment.length : 0 }}/500</div>
            </ng-container>
            <p *ngIf="viewMode === ViewMode.VIEW">
                {{ form.value.completion_time_comment }}
                <span class="text-muted" *ngIf="!form.value.completion_time_comment">Nicht eingetragen</span>
            </p>
        </div>

        <h4>Budget</h4>
        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Projektbudget [€]</label>
                    <p>{{ form.value.cost_budget | number }}</p>
                    <span class="text-danger" *ngIf="!form.value.cost_budget">Nicht eingetragen</span>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Projektkosten [€]</label>
                    <input type="number" class="form-control" formControlName="cost_actual" *ngIf="viewMode !== ViewMode.VIEW">
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.cost_actual | number }}
                        <span class="text-danger" *ngIf="!form.value.cost_actual">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Abweichung [€]</label>
                    <p
                            [class.text-danger]="form.value.cost_actual - form.value.cost_budget > 0"
                            [class.text-success]="form.value.cost_actual - form.value.cost_budget < 0"
                    ><span *ngIf="form.value.cost_actual - form.value.cost_budget > 0">+</span>{{ form.value.cost_actual - form.value.cost_budget}}</p>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <label>Kommentar</label>
            <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                <textarea class="form-control" formControlName="completion_costs_comment" rows="5" [maxlength]="500"
                          placeholder="Falls es ergänzende Bemerkungen oder Abweichungen zu dem definierten Budget gibt, können diese hier erläutert werden.">
                </textarea>
                <div class="mb-1 small">{{ form.value.completion_costs_comment ? form.value.completion_costs_comment.length : 0 }}/500</div>
            </ng-container>
            <p *ngIf="viewMode === ViewMode.VIEW">
                {{ form.value.completion_costs_comment }}
                <span class="text-muted" *ngIf="!form.value.completion_costs_comment">Nicht eingetragen</span>
            </p>
        </div>
    </form>
</div>
